<template>
  <div v-if="items.length" class="truck-scale-timeline">
    <div class="truck-scale-timeline__title">
      <i class="mc-fa icon-outline_clipboard" aria-hidden="true"></i>
      <span>{{ title }}</span>
    </div>

    <div class="truck-scale-timeline__list">
      <template v-for="(item, index) in items">
        <div
          :key="item.key"
          :class="[
            'truck-scale-timeline__item',
            { 'truck-scale-timeline__item--latest': index === items.length - 1 },
          ]"
        >
          <strong>{{ item.label }} {{ item.weight }}</strong>
          <span v-if="item.time" class="truck-scale-timeline__separator">•</span>
          <span v-if="item.time">{{ item.time }}</span>
        </div>
        <i
          v-if="index < items.length - 1"
          :key="`${item.key}-arrow`"
          class="mc-fa icon-outline_arrow-right truck-scale-timeline__arrow"
          aria-hidden="true"
        ></i>
      </template>
    </div>
  </div>
</template>

<script>
import { formatDateWithTz, formatIndexDate } from '@/helpers/tzDate'

const SCALE_KEYS = ['t1', 't2', 't3']

export default {
  name: 'TruckScaleTimeline',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Penimbangan Truk',
    },
    unit: {
      type: String,
      default: 'kg',
    },
  },
  computed: {
    items() {
      const valuesByKey = this.value.reduce((result, item) => {
        if (item && SCALE_KEYS.includes(String(item.key).toLowerCase())) {
          result[String(item.key).toLowerCase()] = item.value
        }
        return result
      }, {})

      return SCALE_KEYS.reduce((result, key) => {
        if (valuesByKey[key] == null || valuesByKey[key] === '') return result

        const [weight, ...timeParts] = String(valuesByKey[key]).split('~')
        const normalizedWeight = weight.trim()
        result.push({
          key,
          label: key.toUpperCase(),
          weight: this.unit && !normalizedWeight.toLowerCase().endsWith(this.unit.toLowerCase())
            ? `${normalizedWeight} ${this.unit}`
            : normalizedWeight,
          time: formatDateWithTz(timeParts.join('~').trim()),
        })
        return result
      }, [])
    },
  },
}
</script>

<style lang="scss" scoped>
.truck-scale-timeline {
  display: flex;
  align-items: center;
  gap: 16px;
  overflow-x: auto;
  padding: 4px;
  color: #243b64;

  &__title,
  &__list,
  &__item {
    display: flex;
    align-items: center;
  }

  &__title {
    flex: 0 0 auto;
    gap: 8px;
    font-weight: 600;
  }

  &__list {
    gap: 12px;
  }

  &__item {
    flex: 0 0 auto;
    gap: 8px;
    border-radius: 6px;
    background: #f3f5f8;
    padding: 6px 10px;
    color: #5c677d;

    strong {
      color: #263958;
    }

    &--latest,
    &--latest strong {
      color: #0969da;
    }

    &--latest {
      background: #eef6ff;
    }
  }

  &__separator,
  &__arrow {
    flex: 0 0 auto;
    color: #7b879b;
  }
}
</style>
